import React, { FC, useEffect } from 'react';

import queryString from 'query-string';

import { Loading } from '../Loading/Loading';

const AuthReturnPage: FC = () => {
    useEffect(() => {
        const { status } = queryString.parse(location.search);
        window.opener.postMessage({ status }, window.location.origin);
    }, []);

    return <Loading centered grow />;
};

export default AuthReturnPage;
